import React from "react";
import Create from "modules/users/components/Create";

const UsersCreatePage = () => {
  return (
    <div>
      <Create />
    </div>
  );
};

export default UsersCreatePage;
